import React, { Component } from 'react';
import StudentProfileBody from './mycomponents/studentprofilebody';
import Navbar from './mycomponents/navbar';
import PalmeeupIcon from './mycomponents/palmeeupbuttonicon';

class StudentProfile extends Component {
    state = {  } 
    render() { 
        return (
            <React.Fragment>
                <Navbar/>
                <StudentProfileBody/>
                <PalmeeupIcon/>
            </React.Fragment>
        );
    }
}
 
export default StudentProfile;